import apiService from "./api";

const limitService = {
  // Get all limits for a company
  getCompanyLimits(params) {
    return apiService.get(`/limits`, params);
  },

  // Get single limit
  getLimit(limitId) {
    return apiService.get(`/limits/${limitId}`);
  },

  // Create new limit
  createLimit(data) {
    return apiService.post(`/limits`, data);
  },

  // Delete limit
  deleteLimit(limitId) {
    return apiService.delete(`/limits/${limitId}`);
  },

  // Duplicate limit
  duplicateLimit(limitId) {
    return apiService.post(`/limits/${limitId}/duplicate`);
  },

  // Toggle limit status
  toggleLimitState(limitId, state) {
    return apiService.put(`/limits/${limitId}/state`, {
      state,
    });
  },

  // Update complete limit params in one request
  updateLimitParams(limitId, payload) {
    return apiService.put(`/limits/${limitId}/params`, payload);
  },

  // Update timing parameters
  updateTiming(limitId, timingData) {
    return apiService.put(`/limits/${limitId}/params/timing`, timingData);
  },

  // Update limit definition
  updateLimitDefinition(limitId, definitionData) {
    return apiService.put(`/limits/${limitId}/params/limit_definition`, definitionData);
  },

  // Update ordering rules
  updateOrderingRules(limitId, orderingData) {
    return apiService.put(`/limits/${limitId}/params/ordering_rules`, orderingData);
  },

  // Update payment logic
  updatePaymentLogic(limitId, paymentData) {
    return apiService.put(`/limits/${limitId}/params/payment_logic`, paymentData);
  },

  // Update rollover policy
  updateRolloverPolicy(limitId, rolloverData) {
    return apiService.put(`/limits/${limitId}/params/rollover_policy`, rolloverData);
  },

  // Get current credit state for a user by limit
  getCurrentUserLimitState(userId) {
    return apiService.get(`/limits/transactions/current-state`, {
      user_id: userId,
    });
  },

  // Get transactions for a limit
  getLimitTransactions(limitId) {
    return apiService.get(`/limits/${limitId}/transactions`);
  },

  // Get all credit transactions for a company
  getCompanyTransactions(companyId) {
    return apiService.get(`/limits/transactions/company/${companyId}`);
  },
};

export default limitService;
